export { default } from './PricingNew';
